import { useEffect } from 'react'
import { useIntersectionContext } from 'marketing-site/src/components/context/IntersectionContext'
export const DEFAULT_OPTIONS = {
  threshold: 0.6,
  root: null,
  rootMargin: '0px 0px -50% 0px',
}

export interface IDefaultOptions {
  threshold?: number
  root?: any
  rootMargin?: string
}

export function useVerticalObserver(parameters?: IDefaultOptions) {
  const { itemRefs, addItem, removeItem } = useIntersectionContext()

  useEffect(() => {
    if (typeof window.IntersectionObserver === 'undefined') return
    const visibilityChanged: IntersectionObserverCallback = function (entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          addItem(entry.target.id)
        } else {
          if (entry.boundingClientRect.top > 0) {
            removeItem(entry.target.id)
          }
        }
      })
    }

    const options = {
      threshold: parameters?.threshold || DEFAULT_OPTIONS.threshold,
      root: parameters?.root || DEFAULT_OPTIONS.root,
      rootMargin: parameters?.rootMargin || DEFAULT_OPTIONS.rootMargin,
    }

    const observer = new IntersectionObserver(visibilityChanged, options)
    itemRefs.map((ref) => {
      const target = ref.current
      if (target) observer.observe(target)
    })
    return () => {
      observer.disconnect()
    }
  }, [itemRefs, addItem, removeItem])

  return { itemRefs }
}
